import { AirSelectedItineraryResponseManager, useJSONFeatureFlag } from 'obt-common';
import { ThirdPartySourceEnum } from 'obt-common/types/api/v1/obt/supplier/third_party_info';

export function useIsFareQuoteThirdPartySourceEnabled(
  airSelectedItineraryResponseManager: AirSelectedItineraryResponseManager | null,
): boolean {
  const featureFlag = useJSONFeatureFlag('FE_AIR_SHARE_FARE_QUOTE_V2');
  if (!airSelectedItineraryResponseManager) {
    return false;
  }

  if (!featureFlag?.enabled || !featureFlag) {
    return false;
  }
  if (featureFlag.all_sources) {
    return true;
  }

  const itineraryAllLegs = airSelectedItineraryResponseManager.GetItineraryAllLegsForItineraryIndex(0);

  const sourcesEnabledPerLeg = itineraryAllLegs.filter((leg) => {
    const { legIndex } = leg;
    const source = airSelectedItineraryResponseManager.GetItinerarySourcePerLegInfo(legIndex);

    /* istanbul ignore next */
    switch (source) {
      case ThirdPartySourceEnum.SABRE:
        return !!featureFlag.sabre;
      case ThirdPartySourceEnum.TRAVEL_FUSION:
        return !!featureFlag.travel_fusion;
      case ThirdPartySourceEnum.NDC:
        return !!featureFlag.ndc;
      case ThirdPartySourceEnum.FARELOGIX_NDC:
        return !!featureFlag.farelogix_ndc;
      case ThirdPartySourceEnum.SOUTHWEST:
        return !!featureFlag.southwest;
      case ThirdPartySourceEnum.CLEARTRIP:
        return !!featureFlag.cleartrip;
      case ThirdPartySourceEnum.KYTE:
        return !!featureFlag.kyte;
      case ThirdPartySourceEnum.AMADEUS:
        return !!featureFlag.amadeus;
      default:
        return false;
    }
  });

  return sourcesEnabledPerLeg.length === itineraryAllLegs.length;
}
